var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('organization-form',{attrs:{"form":_vm.form},on:{"update:form":function($event){_vm.form=$event}}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"loading":_vm.sending,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("\n      Save Organization\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }